import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Block from 'sites/views/block';
import BlockVpn from 'sites/views/block/vpn';
import Router from 'sites/routes/router';
import { push } from 'connected-react-router';
import { appInfoBlockingState } from 'sites/api/MixApi';
import { fetchInitCompleted } from 'sites/state/modules/livestream/actions';
import { setIsSiteInited } from 'sites/state/modules/common/actions';
import QueryParams from 'sites/utils/QueryParams';
import { expiredLastReCAPTCHADay, getMemberBlockType, onInitIntercomeData } from 'sites/utils/utils';
// import { history } from 'sites/state/store';
import BlockedSignIn from 'sites/views/block/blocked-sign-in';
import { screenWidthSelector, siteInfoSelector } from 'sites/state/modules/common/selectors';
import { goToProviderRedirect } from 'sites/api/GuestApi';
import toast from 'common/utils/toast';
import { completedLogin, loginStartOperation } from 'sites/state/modules/login/operations';
import { setInput, setOpenWrongLoginPageModalSelector } from 'sites/state/modules/login/actions';
import { credentialsSelector, fetchingSelector, errorSelector, openWrongLoginPageModalStateSelector } from 'sites/state/modules/login/selectors';
import { getBrowserName } from 'common/utils/utils';
import Button from 'common/components/elements/buttons/primary';
import CreateEditModal from 'common/components/modules/modal-wrapper';
import { smartlookInit, smartlookIdentify } from 'sites/utils/smartlook';

class BlockContainer extends Component {
   static propTypes = {
      goToHomePage: PropTypes.func,
      closeLivestreamPopap: PropTypes.func,
      screenWidth: PropTypes.number,
      goTo: PropTypes.func,
      location: PropTypes.object,
      credentials: PropTypes.object.isRequired,
      login: PropTypes.func.isRequired,
      onInputChange: PropTypes.func.isRequired,
      loading: PropTypes.bool,
      errors: PropTypes.object,
      siteInfo: PropTypes.object,
      openWrongLoginPageModalState: PropTypes.object,
      closeWrongLoginModal: PropTypes.func,
      completedLogin: PropTypes.func,
   }
   state = {
      data: {},
      isOpenSignIn: false,
   }

   isVpnBlocked = window.isVpnBlocked;
   isCountryBlocked = window.isCountryBlocked;
   isRegionBlocked = window.isRegionBlocked;
   timeout = null;

   async componentDidMount(){
      if(!window.isBlocked){
         const { goToHomePage } = this.props;
         !window.blockedAdditionalData &&  goToHomePage();
         return
      }
      this.init();

      let provider = QueryParams.getParam('provider')
      if(provider) {
         let providerName = 'X'
         switch (provider) {
            case 'sharesome':
               providerName = 'Sharesome'
               break;
            case 'google':
               providerName = 'Google'
               break;
            default:
               break;
         }
         toast.error(`We are unable to authorize with ${ providerName }, please use another method`);
         QueryParams.removeQueryParam('provider');
      }

      // if(window.isVpnBlocked) {
      //    const { goToHomePage } = this.props;
      //    return goToHomePage()
      // }


      // const intercomData = window.blockedAdditionalData.additional_info;
      // onInitIntercomeData(intercomData)

      if(this.canStreamOnSmartlook()){
         smartlookInit();
         const siteInfo = window?.blockedAdditionalData?.additional_info?.site_info;
         if(siteInfo){
            const email = window?.blockedAdditionalData?.additional_info?.user?.email;
            const username = window?.blockedAdditionalData?.additional_info?.user?.username || '';
            let name = `${ siteInfo.site_long_name }`;
            if(username){
               name = `${ name }/${ username }`
            }
            this.timeout =  setTimeout(() => {
               smartlookIdentify(siteInfo.app_id, {
                  name: name,
                  email: email,
               })

            }, 100);
         }
      }
   }
   componentWillUnmount(){
      if(this.timeout){
         clearTimeout(this.timeout)
      }
   }

   canStreamOnSmartlook = () => {
      const vpnBlocked = QueryParams.getParsedSearchParams()?.vpn_blocked === 'true';
      if(this.isVpnBlocked || vpnBlocked){
         return true;
      }
      const siteInfo = window?.blockedAdditionalData?.additional_info?.site_info;
      const regionBlocked = QueryParams.getParsedSearchParams()?.region_blocked === 'true';
      const city = siteInfo?.location?.city;
      if(city && (this.isRegionBlocked || regionBlocked) && ['louisiana', 'texas'].includes(city.toLocaleLowerCase())){
         return true;
      }
      return false;

   }

   init = async () => {
      const { closeLivestreamPopap } = this.props;
      const chatSocket = window.siteChatSocket
      const liveStreamSocket = window.siteLiveStreamSocket
      closeLivestreamPopap();
      if(chatSocket && chatSocket.connected) {
         chatSocket.disconnect()
         window.siteChatSocket = null
      }
      if(liveStreamSocket && liveStreamSocket.connected) {
         liveStreamSocket.disconnect()
         window.siteLiveStreamSocket = null
      }
      const { data } = await appInfoBlockingState();
      this.setState({ data })
      window.document.title = data.site_long_name;
      const titleElement = window.document.querySelector('title');
      if(titleElement?.classList?.add){
         titleElement.classList.add('notranslate');
      }
      const faviconRel = document.querySelector("link[rel='shortcut icon']");
      if(faviconRel) {
         faviconRel.href = data.favicon;
      }
   }


   onClickIntercom =  () => {
      const intercomData = window.blockedAdditionalData.additional_info;
      onInitIntercomeData(intercomData)
      window.Intercom('show')
   }

   onOpenSignIn = () => {
      this.setState({
         isOpenSignIn: true,
      })
   }

   onCloseSignIn = () => {
      this.setState({
         isOpenSignIn: false,
      })
   }

   onClickButton = (type) => {
      const { goTo, location } = this.props;
      switch (type) {
         case 'email' :
            goTo(Router.route("SIGN_IN_EMAIL").getCompiledPath(), location.search)
            break;
         case 'google' :
         case 'twitter' :
         case 'sharesome' :
            this.goToRedirect(type)
            break;
         default:
            break;
      }
   }

   goToRedirect = (socialType) => {
      const { location } = this.props;
      goToProviderRedirect(socialType, 'sign-in', location.search)
         .then(res => {
            if(!!res?.data) {
               window.open(res?.data, '_self')
            } else {
               toast.error('Something went wrong')
            }
         })
         .catch(err => {
            toast.error('Something went wrong')
         })
   }

   onLogin = () => {
      const { credentials: { email, password }, login, location } = this.props;
      const data = {
         email,
         password,
      };
      window.sharedData.stories.lastUpdateDate = undefined;
      login(data, location.search, window?.blockedAdditionalData?.additional_info?.site_info?.current_login_api);
   }


   isCaptchaEnabled = () => {
      const { siteInfo } = this.props;
      const browserName = getBrowserName();
      if('safari' === browserName){
         return false;
      }
      if(siteInfo?.is_captcha_enabled){
         return expiredLastReCAPTCHADay()
      }
      return false
   }

   render() {
      const { data, isOpenSignIn } = this.state;
      const { screenWidth } = this.props;
      const {
         goToHomePage,
         siteInfo,
         credentials: {
            email,
            password,
         },
         onInputChange,
         loading,
         errors,
         openWrongLoginPageModalState,
         closeWrongLoginModal,
         completedLogin,
      } = this.props
      const vpnBlocked = QueryParams.getParsedSearchParams()?.vpn_blocked === 'true'
      const countryBlocked = QueryParams.getParsedSearchParams()?.country_blocked === 'true'
      const regionBlocked = QueryParams.getParsedSearchParams()?.region_blocked === 'true'
      return (
         <>
            {
               (this.isVpnBlocked || vpnBlocked) && (
                  <BlockVpn
                     logo={ data.site_logo }
                     goToHomePage={ goToHomePage }
                     onClickIntercom={ this.onClickIntercom }
                     goToSignIn={ () => {
                        // history.push(Router.route('SIGN_IN').getCompiledPath() + `?vpn_blocked=true&showSignIn=true`)
                        this.onOpenSignIn()
                        localStorage.setItem('v_block', 'true')
                     } }
                     // data={ window?.blockedAdditionalData?.additional_info }
                  />
               )
            }
            {
               (!this.isVpnBlocked || !vpnBlocked) &&  (
                  <Block
                     isMemberBanned={ window.memberBanned }
                     goToHomePage={ goToHomePage }
                     onClickIntercom={ this.onClickIntercom }
                     data={ window?.blockedAdditionalData?.additional_info }
                     countryBlocked={ countryBlocked || this.isCountryBlocked }
                     regionBlocked={ regionBlocked || this.isRegionBlocked }
                     goToSignIn={ () => {
                        // history.push(Router.route('SIGN_IN').getCompiledPath() + `?${ getMemberBlockTypeValue() }=true&showSignIn=true`)
                        this.onOpenSignIn()
                        localStorage.setItem(getMemberBlockType(), 'true')
                     } }
                  />
               )
            }
            {
               isOpenSignIn &&
                  <BlockedSignIn
                     onClose={ () => this.onCloseSignIn() }
                     screenWidth={ screenWidth }
                     onClickButton={ this.onClickButton }
                     refCode={ siteInfo?.referal_code }
                     onLogin={ this.onLogin }
                     onInputChange={ onInputChange }
                     email={ email }
                     password={ password }
                     loading={ loading }
                     errors={ errors }
                     contactUs={ () => {} }
                     isCaptchaEnabled={ this.isCaptchaEnabled() } // TODO SHOW ReCAPTCHA every 30 days
                     // forgotPassword={ () => goTo(Router.route('PASSWORD_RESET').getCompiledPath()) }
                     // gotToSignUp={ (isBlockedSignUp) ? null : () => goTo(Router.route("SIGN_UP").getCompiledPath(), location.search) }
                     isDemoMode={ siteInfo?.is_demo_mode }
                  />
            }
            {
               openWrongLoginPageModalState?.isOpen && (
                  <CreateEditModal
                     icon='warning'
                     type='confirm'
                     iconColor='warning'
                     descriptionColorClass='text-secondary'
                     onCloseModal={ () => {
                        if(!openWrongLoginPageModalState?.token){
                           closeWrongLoginModal();
                           return;
                        }
                        completedLogin(openWrongLoginPageModalState.token, openWrongLoginPageModalState.searchType);
                     } }
                     title='Wrong log in page'
                     cancelText='Ok'
                     withoutConfirmButton
                     contentWidth='375px'
                     // isMobile={ isMobile }
                     buttonClassName='mt-8'
                     // iconSize='2xl'
                     // isCloseAction
                     isPreventDeafault={ false }
                  >
                     <div className='flex flex-col mt-4 gap-8 items-center'>
                        <span className=' text-secondary dark:text-secondary-dark text-base leading-[19px]'>
                           To access your site’s Dashboard, please log in at <a target='_blank' rel='noopener noreferrer ' href='https://mymember.site/' className='skin-primary-text hover:underline'>my<span className='font-semibold'>member.</span>site</a>
                        </span>
                        <div className='flex flex-col gap-3'>
                           <div className='flex justify-center items-center h-9'>
                              <Button
                                 text='Contact support'
                                 textColor='secondary dark:text-secondary-dark'
                                 textSize='small'
                                 backgroundColor='transparent'
                                 onClick={ () => {} }
                                 classNames='px-[14px] py-2 intercom-wrong-log-in-page'
                              />
                           </div>
                           <a rel='noopener noreferrer' href='https://mymember.site/' className='flex justify-center items-center h-9 group'>
                              <span className='skin-primary-text text-sm leading-[20px]  group-hover:underline'>
                                 Go to my<span className='font-semibold'>member.</span>site
                              </span>
                           </a>
                        </div>
                     </div>
                  </CreateEditModal>
               )
            }
         </>

      )
   }
}
const mapStateToProps = (state) => ({
   screenWidth: screenWidthSelector(state),
   credentials: credentialsSelector(state),
   loading: fetchingSelector(state),
   errors: errorSelector(state),
   siteInfo: siteInfoSelector(state),
   openWrongLoginPageModalState: openWrongLoginPageModalStateSelector(state),
})

const mapDispatchToProps = (dispatch) => {
   return {
      goToHomePage: () => {
         dispatch(setIsSiteInited(false))
         dispatch(push(Router.route('HOMEPAGE').getCompiledPath() + window?.location.search))
      },
      closeLivestreamPopap: () => dispatch(fetchInitCompleted({ is_show_banner: false })),
      goTo: (location, search = '') => {
         dispatch(push({
            location,
            search,
         }))
      },
      login: (data, searchType, suffix) => {
         dispatch(loginStartOperation(data, searchType, suffix));
      },
      completedLogin: (token, searchType) => {
         dispatch(completedLogin(token, searchType));
      },
      onInputChange: (key, value) => {
         dispatch(setInput(key, value))
      },
      closeWrongLoginModal: _ => {
         dispatch(setOpenWrongLoginPageModalSelector({ isOpen: false, token: null, searchType: null }))
      },
   }
}


export default connect(mapStateToProps, mapDispatchToProps)(BlockContainer);
